import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const setUpArrowIconSmallPosition = (position: 'up' | 'right' | 'down' | 'left'): string => {
    if (position === 'right') {
        return 'rotate(90deg)';
    }

    if (position === 'down') {
        return 'rotate(180deg)';
    }

    if (position === 'left') {
        return 'rotate(-90deg)';
    }

    return 'rotate(0)';
};

interface SvgElementPropsType {
    position: 'up' | 'right' | 'down' | 'left';
}

const SvgElement = styled('svg', { label: 'SvgElement' })<SvgElementPropsType>`
    fill: currentcolor;
    height: auto;
    transform: ${({ position }): string => setUpArrowIconSmallPosition(position)};
    transition: transform 0.2s ease;
`;

interface UpArrowIconSmallPropsType {
    className?: string;
    onClick?: (e: React.SyntheticEvent) => void;
    position: 'up' | 'right' | 'down' | 'left';
}

export const UpArrowIconSmall = observer(
    'UpArrowIconSmall',
    ({ className, onClick, position }: UpArrowIconSmallPropsType): JSX.Element => {
        return (
            <SvgElement
                className={className}
                height='16'
                onClick={onClick}
                position={position}
                viewBox='0 0 16 16'
                width='16'
                xmlns='http://www.w3.org/2000/svg'
            >
                <mask
                    id='mask0_135_41756'
                    style={{ maskType: 'alpha' }}
                    maskUnits='userSpaceOnUse'
                    x='4'
                    y='5'
                    width='8'
                    height='5'
                >
                    <path
                        d='M7.99999 7.2L5.39999 9.8C5.27777 9.92222 5.12221 9.98333 4.93333 9.98333C4.74444 9.98333 4.58888 9.92222 4.46666 9.8C4.34444 9.67778 4.28333 9.52222 4.28333 9.33333C4.28333 9.14444 4.34444 8.98889 4.46666 8.86667L7.53333 5.8C7.66666 5.66667 7.82221 5.6 7.99999 5.6C8.17777 5.6 8.33333 5.66667 8.46666 5.8L11.5333 8.86667C11.6555 8.98889 11.7167 9.14444 11.7167 9.33333C11.7167 9.52222 11.6555 9.67778 11.5333 9.8C11.4111 9.92222 11.2555 9.98333 11.0667 9.98333C10.8778 9.98333 10.7222 9.92222 10.6 9.8L7.99999 7.2Z'
                        fill='#1C1B1F'
                    />
                </mask>
                <g mask='url(#mask0_135_41756)'>
                    <rect
                        width='16'
                        height='16'
                        fill='currentcolor'
                    />
                </g>
            </SvgElement>
        );
    }
);
